import {
  styled_components_browser_esm_default
} from "./chunk-OMPJY3VL.js";
import {
  require_react
} from "./chunk-BODSDBIB.js";
import {
  __toESM
} from "./chunk-TFWDKVI3.js";

// node_modules/@myportal/ecedo-myportal-frontend-components/elements/PageTitle.js
var import_react = __toESM(require_react());
var __makeTemplateObject = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var Title = styled_components_browser_esm_default.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1.875rem;\n  line-height: 1.875rem;\n  color: #2b6cb0;\n  width: 100%;\n"], ["\n  font-size: 1.875rem;\n  line-height: 1.875rem;\n  color: #2b6cb0;\n  width: 100%;\n"])));
var Subtitle = styled_components_browser_esm_default.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n  color: #63b3ed;\n  width: 100%;\n  margin-bottom: 1.5rem;\n  font-weight: 300;\n"], ["\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n  color: #63b3ed;\n  width: 100%;\n  margin-bottom: 1.5rem;\n  font-weight: 300;\n"])));
var PageTitle = function(_a) {
  var title = _a.title, subtitle = _a.subtitle;
  return import_react.default.createElement(
    import_react.default.Fragment,
    null,
    import_react.default.createElement(Title, null, title),
    subtitle && import_react.default.createElement(Subtitle, null, subtitle)
  );
};
var PageTitle_default = PageTitle;
var templateObject_1;
var templateObject_2;

export {
  PageTitle_default
};
//# sourceMappingURL=chunk-3YANOUQQ.js.map
